import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import { setStore } from './api/apiClient';
import AuthProvider from './components/AuthProvider';
import App from './App';
import { clearAuthState } from './utils/tokenUtils';
import { initPostHog } from './utils/posthogInit';

// Initialize PostHog analytics
initPostHog();

// Set store reference for API client
setStore(store);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </Provider>
);